import {CopyToClipboardButton} from '@github-ui/copy-to-clipboard/Button'
import {CopyIcon} from '@primer/octicons-react'
import {Dialog} from '@primer/react/experimental'

import styles from './BranchNextStepLocal.module.css'

export type BranchNextStepLocalProps = {
  branch: string | null
  onClose: () => void
}

export const BranchNextStepLocal = ({branch, onClose}: BranchNextStepLocalProps) => {
  const content = `git fetch origin
git checkout ${branch}`

  return (
    <Dialog width="large" height="auto" title={'Checkout in your local repository'} onClose={onClose}>
      <span className={styles.localInstructionsText}>Run the following commands in your local clone.</span>
      <div className={styles.commandContainer}>
        <span className={styles.commandText}>{content}</span>
        <CopyToClipboardButton
          textToCopy={content}
          ariaLabel={'Copy to clipboard'}
          icon={CopyIcon}
          tooltipProps={{direction: 'w'}}
        />
      </div>
    </Dialog>
  )
}
